import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

import { apiFetch } from "./api";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const periods = [
  { key: "1", label: "1º Periodo" },
  { key: "2", label: "2º Periodo" },
  { key: "3", label: "3º Periodo" },
  { key: "4", label: "4º Periodo" },
  { key: "5", label: "5º Periodo" },
  { key: "6", label: "6º Periodo" },
  { key: "7", label: "7º Periodo" },
  { key: "8", label: "8º Periodo" },
  { key: "9", label: "9º Periodo" },
  { key: "10", label: "10º Periodo" },
];

export const years = Array.from({ length: 35 }, (_, i) => {
  const year = 9 + new Date().getFullYear() - i;
  return { key: year.toString(), label: year.toString() };
});

// GET na rota cursos
export interface Cursos {
  nome: string;
  id_curso: string;
  descricao: string;
  habilitado: boolean;
  lista_periodos: string[];
}

export const fetchCursos = async (token: string, callback: (value: Cursos[]) => void) => {
  const res = await apiFetch("/cursos", {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
  });

  const data = await res.json();

  if (res.ok) {
    callback(data);
    return null;
  } else if (!res.ok) {
    return {
      title: "Erro ao encontrar os cursos",
      description: "Tente novamente mais tarde",
    };
  }
};
